"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesktopAndTabletLargeDevice = exports.DesktopAndTabletDevice = exports.DesktopDevice = exports.TabletDevice = exports.MobileDevice = exports.getDeviceType = exports.isClientSide = exports.isServerSide = exports.isTablet = exports.isDesktop = exports.isMobile = void 0;
var React = require("react");
var DetectProvider_1 = require("./DetectProvider");
var MD_UP = '(min-width:900px)';
var MD_DOWN = '(max-width:899.95px)';
var MD_ONLY = '(min-width:900px) and (max-width:1199.95px)';
var LG_UP = '(min-width:1200px)';
var isServerSide = function () { return typeof window === 'undefined'; };
exports.isServerSide = isServerSide;
var isClientSide = function () { return typeof window !== 'undefined' && typeof window.navigator !== undefined; };
exports.isClientSide = isClientSide;
var isMobile = function () {
    return typeof window !== 'undefined' && window.matchMedia !== undefined && window.matchMedia(MD_DOWN).matches;
};
exports.isMobile = isMobile;
var isDesktop = function () {
    return typeof window !== 'undefined' && window.matchMedia !== undefined && window.matchMedia(MD_UP).matches;
};
exports.isDesktop = isDesktop;
var isTablet = function () {
    return typeof window !== 'undefined' && window.matchMedia !== undefined && window.matchMedia(MD_ONLY).matches;
};
exports.isTablet = isTablet;
var isDesktop2 = function () {
    return typeof window !== 'undefined' && window.matchMedia !== undefined && window.matchMedia(LG_UP).matches;
};
var getDeviceType = function () { return (isDesktop() ? 'D' : isMobile() ? 'M' : 'T'); };
exports.getDeviceType = getDeviceType;
var MobileDevice = function (props) {
    var isMobileDevice = React.useContext(DetectProvider_1.DetectContext).isMobileDevice;
    return (isClientSide() && isMobile()) || (isServerSide() && isMobileDevice()) ? props.children : null;
};
exports.MobileDevice = MobileDevice;
var TabletDevice = function (props) {
    var isTabletDevice = React.useContext(DetectProvider_1.DetectContext).isTabletDevice;
    return (isClientSide() && isTablet()) || (isServerSide() && isTabletDevice()) ? props.children : null;
};
exports.TabletDevice = TabletDevice;
var DesktopDevice = function (props) {
    var isDesktopDevice = React.useContext(DetectProvider_1.DetectContext).isDesktopDevice;
    return (isClientSide() && isDesktop2()) || (isServerSide() && isDesktopDevice()) ? props.children : null;
};
exports.DesktopDevice = DesktopDevice;
var DesktopAndTabletDevice = function (props) {
    var _a = React.useContext(DetectProvider_1.DetectContext), isTabletDevice = _a.isTabletDevice, isDesktopDevice = _a.isDesktopDevice;
    return (isClientSide() && isDesktop()) || (isServerSide() && (isTabletDevice() || isDesktopDevice()))
        ? props.children
        : null;
};
exports.DesktopAndTabletDevice = DesktopAndTabletDevice;
var DesktopAndTabletLargeDevice = function (props) {
    var _a = React.useContext(DetectProvider_1.DetectContext), isTabletDevice = _a.isTabletDevice, isDesktopDevice = _a.isDesktopDevice;
    return (isClientSide() && isDesktop()) || (isServerSide() && (isTabletDevice() || isDesktopDevice()))
        ? props.children
        : null;
};
exports.DesktopAndTabletLargeDevice = DesktopAndTabletLargeDevice;
